/**
 * 用于及时调整CSR及SSR模式的中间件
 * @param {*} asyncCb CSR/SSR拉取数据的函数，传入参数保持与asyncData一致
 *
 * mounted后需执行的逻辑可放在afterMounted方法中
 */

import { handleRoute } from '@/middleware/route-handler';

export default function (asyncCb) {
  return {
    async asyncData(params) {
      const { store } = params;

      // 假如是ssr模式渲染ssr
      if (store.state.common.renderData.mode === 'ssr' && asyncCb) {
        return await asyncCb(params);
      }
    },

    async mounted() {
      // 全局处理route，保持与后端一致
      handleRoute(this.$route);
      // 假如是需要前端渲染
      if (this.$store.state.common.renderData.mode === 'csr' && asyncCb) {
        const res = await asyncCb({
          app: this,
          query: this.$route.query,
          params: this.$route.params,
          store: this.$store,
          route: this.$route,
        }).catch((err) => {
          console.log('async err', err);
          return {};
        });

        Object.keys(res).forEach((key) => {
          this[key] = res[key];
        });
      }

      // 设置loading
      this.$store.commit('common/setRenderData', { loading: false });

      this.$nextTick(() => {
        this.afterMounted && this.afterMounted();
      });
    },
  };
}
